import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'component.footerDownloadApp.title',
    defaultMessage: 'Direct scheduling available through apps',
  },
})